export const USER = '/api/v1/auth/user';
export const USER_ACCOUNT_ACTIVE = `${USER}/active`;
export const ACTIVATE_USER = '/api/v1/auth/user/activate';
export const VERIFY_TOKEN_EXPIRATION = '/api/v1/auth/token-expired';
